import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { ThemeProvider } from './context/ThemeProvider';
import { Layout } from './components/Layout';
import { Landing } from './pages/Landing';
import { About } from './pages/About';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Projects } from './pages/Projects';
import { Contact } from './pages/Contact';
import { PrishaLetters } from './pages/PrishaLetters';
import { Visits } from './pages/Visits';
import { NotFound } from './pages/NotFound';

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/letters-to-prisha" element={<PrishaLetters />} />
            <Route path="/visits" element={<Visits />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        <Analytics />
      </BrowserRouter>
    </ThemeProvider>
  );
}
